import React, { createContext } from 'react';
import mitt from 'mitt';

export const emitter = mitt();
export const EmitterContext = createContext(emitter);
export const withEmitter = (Wrapped) => (props) =>
  <EmitterContext.Consumer>{(instance) => <Wrapped emitter={instance} {...props} />}</EmitterContext.Consumer>;
export default EmitterContext;
